
<script>
import { categoryService } from "../../services";
import { required, requiredIf } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, replaceByDefault } from "../../Helper/helper";
import { success_message } from "../../Helper/helper";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import { routes } from "../../config/api_routes";

export default {
  components: { DropzonePopup },
  data() {
    return {
      checked: true,
      file1: null,
      url: null,
      config: config,
      checked: true,
      file1: null,
      url: null,
      config: config,
      attrName :{},
      attrValue :{},
      category: {
        category_id: "",
        category_name: "",
        category_name_thai: "",
        category_desc: "",
        category_desc_thai: "",
        color_code: "#f2f3f4",
        text_color_code: "#000000",
        status: "1",
        is_coupon_applicable: "1",
        is_pickup_dis_applicable: "1",
        is_subs_discount_applicable: 0,
        category_img: null,
        navigation_image: null,
        vendor_id: '',
        //attributes :[],
      },
      category_img: "",
      category_image_path: "",
      category_image_delete_url: routes.categoryImageDeleteUrl,
      navigation_image: "",
      navigation_image_path: "",
      navigation_image_delete_url: routes.navigationImageDeleteUrl,
      category_id: "",
    };
  },
  validations: {
    category: {
      category_name: {
        required,
      },
      category_name_thai: {
        required
      },
      category_desc: {
        required,
      },
      category_desc_thai: {
        required
      },
      category_img: {
        required: requiredIf(function (nestedModel) {
          return !(!!this.category_img || !!this.category.category_img);
        }),
      },
      navigation_image: {
        required: requiredIf(function (nestedModel) {
          return !(!!this.navigation_image || !!this.category.navigation_image);
        }),
      }
    },
  },
  mounted() {
    this.getCategoryById();
    //this.getAttribute();
  },
  methods: {
    onCategoryImagedeleted(value) {
      this.category_img = "";
    },
    onNavigationImagedeleted(value) {
      this.navigation_image = "";
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.category.category_img = file;
    },
    getAttribute(){
      categoryService.getAttribute().then((response) => {
        this.attrName = response.data.result;
      });
    },
    getCategoryById() {
      categoryService
        .getCategoryById({ category_id: this.$route.params.category_id })
        .then((response) => {
          const {
            category_id,
            category_name,
            category_name_thai,
            category_desc,
            category_desc_thai,
            status,
            is_coupon_applicable,
            is_pickup_dis_applicable,
            is_subs_discount_applicable,
            text_color_code,
            color_code,
          } = response.data.result.data;
          this.category_image_path = response.data.result.data.category_image_path;
          this.navigation_image_path = response.data.result.data.navigation_image_path;
          this.category_img = response.data.result.data.category_img;
          this.navigation_image = response.data.result.data.navigation_image;
          this.category_id = response.data.result.data.category_id;
          this.category.attributes = response.data.result.attributes;
          this.category = {
            category_id,
            category_name,
            category_name_thai,
            category_desc,
            category_desc_thai,
            status,
            is_coupon_applicable,
            is_pickup_dis_applicable,
            is_subs_discount_applicable,
            text_color_code,
            color_code
          };
        });
    },
    categoryInIt() {
      this.$v.category.$touch();
      if (this.$v.category.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 200, function() {
                $(".is-invalid:first").focus();
            });
        },200);
        return;
      } else {
        //if(this.category.attributes.material.length > 0 || this.category.attributes.size.length > 0){
          categoryService.updateCategoryById(this.category).then((response) => {
            if (response.data.code === 200) {
              success_message(response.data.message);
              this.$router.push({ name: "category-list" });
            } else {
              error_message(response.data.message);
            }
          });
        // }else{
        //   error_message('Please Select Attribute');
        // }
      }
    },
  },
};
</script>

<template>
  <b-form @submit.prevent="categoryInIt">
    <!-- Category Info Start -->
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{ trans.get('__JSON__.Category Info') }}</h4>
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="form-group">
            <input
              id="category_id"
              name="category_id"
              type="hidden"
              @id="category_id"
              v-model="category.category_id"
              class="form-control"
            />
          </div>
          <div class="col-sm-6" v-if="$auth.setting">
            <b-form-group
              id="input-group-1"
              :label="trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[0].name})"
              label-for="category_name" label-class="required"
            >
              <b-form-input
                id="category_name"
                name="category_name"
                v-model="$v.category.category_name.$model"
                type="text"
                :placeholder="trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[0].name})"
                :class="{ 'is-invalid': $v.category.category_name.$error }"
              ></b-form-input>
              <div v-if="$v.category.category_name.$error" class="invalid-feedback">
                <span
                  v-if="!$v.category.category_name.required"
                >{{ trans.get('__JSON__.Please Enter category Name Error') }}.</span>
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6 d-none" v-if="$auth.langauges[1].name === 'No Secondary Language'">
          </div>
          <div class="col-sm-6" v-else>
            <b-form-group
              id="input-group-1"
              :label="trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[1].name })"
              label-for="v" label-class="required"
            >
              <b-form-input
                id="category_name_thai"
                name="category_name_thai"
                v-model="$v.category.category_name_thai.$model"
                type="text"
                :placeholder="trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[1].name })"
                :class="{ 'is-invalid': $v.category.category_name_thai.$error }"
              ></b-form-input>
              <div v-if="$v.category.category_name_thai.$error" class="invalid-feedback">
                <span
                  v-if="!$v.category.category_name_thai.required"
                >{{ trans.get('__JSON__.Please Enter category Name Error') }}.</span>
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6">
            <b-form-group
              id="input-group-1"
              :label="trans.trans('__JSON__.Category Description Language',{lang: $auth.langauges[0].name })"
              label-for="category_desc" label-class="required"
            >
              <b-form-textarea
                rows="5"
                id="category_desc"
                v-model="$v.category.category_desc.$model"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Category Description Language',{lang: $auth.langauges[0].name })"
                name="category_desc"
                :class="{ 'is-invalid': $v.category.category_desc.$error }"
              ></b-form-textarea>
              <div v-if="$v.category.category_desc.$error" class="invalid-feedback">
                <span
                  v-if="!$v.category.category_desc.required"
                >{{ trans.get('__JSON__.Please Enter Category Description Error') }}.</span>
              </div>
            </b-form-group>
          </div>

          <div class="col-sm-6 d-none" v-if="$auth.langauges[1].name === 'No Secondary Language'">
          </div>
          <div class="col-sm-6" v-else>
            <b-form-group
              id="input-group-1"
              :label="trans.trans('__JSON__.Category Description Language',{ lang: $auth.langauges[1].name })"
              label-for="category_desc_thai" label-class="required"
            >
              <b-form-textarea
                rows="5"
                id="category_desc_thai"
                v-model="$v.category.category_desc_thai.$model"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Category Description Language',{ lang: $auth.langauges[1].name })"
                name="category_desc_thai"
                :class="{ 'is-invalid': $v.category.category_desc_thai.$error }"
              ></b-form-textarea>
              <div v-if="$v.category.category_desc_thai.$error" class="invalid-feedback">
                <span
                  v-if="!$v.category.category_desc_thai.required"
                >{{ trans.get('__JSON__.Please Enter Category Description Error') }}.</span>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-6 vendor-status">
              <b-form-group
                id="input-group-2"
                :label="trans.get('__JSON__.Status')"
                label-for="Status"
              >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="swtich-data">
                      <label class="switch">
                        <input
                          type="checkbox"
                          id="togBtn"
                          class="switch-on"
                          name="status"
                          v-model="category.status"
                          true-value="1"
                          false-value="0"
                        />
                        <div class="slider round">
                          <!--ADDED HTML -->
                          <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                          <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                          <!--END-->
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </b-form-group>
          </div>

          <div class="col-md-6 vendor-status">
              <b-form-group
                id="input-group-2"
                :label="trans.get('__JSON__.Coupon Applicable')"
                label-for="is_coupon_applicable"
              >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="swtich-data">
                      <label class="switch">
                        <input
                          type="checkbox"
                          id="togBtn"
                          class="switch-on"
                          name="is_coupon_applicable"
                          v-model="category.is_coupon_applicable"
                          true-value="1"
                          false-value="0"
                        />
                        <div class="slider round">
                          <!--ADDED HTML -->
                          <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                          <span class="off">{{ trans.get('__JSON__.No') }}</span>
                          <!--END-->
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </b-form-group>
          </div>

          <div class="col-md-6 vendor-status">
              <b-form-group
                id="input-group-2"
                :label="trans.get('__JSON__.Pickup Discount Applicable')"
                label-for="is_pickup_dis_applicable"
              >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="swtich-data">
                      <label class="switch">
                        <input
                          type="checkbox"
                          id="togBtn"
                          class="switch-on"
                          name="is_pickup_dis_applicable"
                          v-model="category.is_pickup_dis_applicable"
                          true-value="1"
                          false-value="0"
                        />
                        <div class="slider round">
                          <!--ADDED HTML -->
                          <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                          <span class="off">{{ trans.get('__JSON__.No') }}</span>
                          <!--END-->
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </b-form-group>
          </div>

          <!-- <div class="col-md-6 vendor-status">
            <b-form-group
              id="input-group-2"
              :label="trans.get('__JSON__.Subscription Discount Applicable')"
              label-for="is_subs_discount_applicable"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="swtich-data">
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        class="switch-on"
                        name="is_subs_discount_applicable"
                        v-model="category.is_subs_discount_applicable"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                        <span class="off">{{ trans.get('__JSON__.No') }}</span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div> -->

          <div class="col-md-6">
            <div class="row">
              <div class="col-sm-6">
                <b-form-group
                  id="input-group-2"
                  :label="trans.get('__JSON__.Menu Color Code')"
                  label-for="Menu Color Code"
                ></b-form-group>
              </div>
              <div class="col-sm-6">
                <b-form-group
                  id="input-group-2"
                  :label="trans.get('__JSON__.Text Color Code')"
                  label-for="Text Color Code"
                ></b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <input
                  type="color"
                  id="colorpickers1"
                  v-model="category.color_code"
                  name="color_code"
                  pattern="^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$"
                  value="#f2f3f4"
                />
              </div>
              <div class="col-sm-6">
                <input
                  type="color"
                  id="colorpickers1"
                  v-model="category.text_color_code"
                  name="text_color_code"
                  pattern="^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$"
                  value="#000000"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Category Info End -->

    <!-- Category Attributes Start -->
    <!-- <div class="card">
      <div class="card-body">
        <h4 class="card-title required">{{ trans.get('__JSON__.Category Attributes') }}</h4>
        <p class="card-title-desc"></p>
        <div class="row" v-for="(v,i) in Object.keys(attrName)" :key="i">
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ v }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group cust-checkbox">
              <template v-for="item in attrName[v]">
                <input type="checkbox" :id="item.id + '_checkbox'" :value="item.id" :key="item.id" v-model="category.attributes[v]">
                <label :for="item.id" :key="item.id + '_name'">{{ item.att_name }}</label>
            </template>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Category Attributes End -->

    <!-- Category Image Start -->
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 class="card-title required">{{ trans.get('__JSON__.Category Image') }}</h4>
            <p class="card-title-desc"></p>
            <dropzone-popup
              v-model="category.category_img"
              id="category_img"
              acceptedFiles=".jpeg,.jpg,.png"
              :editable-images="category_img"
              :media-path="category_image_path+'/original'"
              :delete-path="category_image_delete_url"
              @image-deleted="this.onCategoryImagedeleted"
            />
            <div v-if="$v.category.category_img.$error" class="invalid-feedback cuisine-img">
              <span
                v-if="!$v.category.category_img.required"
              >{{ trans.get('__JSON__.Please Select Category Image Error') }}.</span>
            </div>
          </div>

          <div class="col-sm-6">
            <h4 class="card-title required">{{ trans.get('__JSON__.Category Image For Navigation') }}</h4>
            <p class="card-title-desc"></p>
            <dropzone-popup
              v-model="category.navigation_image"
              id="navigation_image"
              acceptedFiles=".jpeg,.jpg,.png"
              :editable-images="navigation_image"
              :media-path="navigation_image_path+'/original'"
              :delete-path="navigation_image_delete_url"
              @image-deleted="this.onNavigationImagedeleted"
            />
            <div v-if="$v.category.navigation_image.$error" class="invalid-feedback cuisine-img">
              <span
                v-if="!$v.category.navigation_image.required"
              >{{ trans.get('__JSON__.Please select navigation image') }}.</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Update Category') }}</button>
            <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
            <router-link
              :to="{name:'category-list'}"
            >
              <b-button
                type="button" 
                variant="secondary" 
                class="mt-3">
                {{ trans.get('__JSON__.Cancel') }}
              </b-button>
            </router-link>  
          </div>
        </div>
      </div>
    </div>
    <!-- Category Image End -->
  </b-form>
</template>

<style>
</style>